import { render, staticRenderFns } from "./Auth_comp.vue?vue&type=template&id=18c7f56a&scoped=true&"
import script from "./Auth_comp.vue?vue&type=script&lang=js&"
export * from "./Auth_comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7f56a",
  null
  
)

export default component.exports